import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getCultPostBySlug, getStrapiConfigured } from '../utils/strapi';

const CultPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;

    const load = async () => {
      try {
        setError('');
        setLoading(true);

        if (!getStrapiConfigured()) {
          throw new Error('Cult is not configured. Set VITE_STRAPI_URL.');
        }

        const data = await getCultPostBySlug(slug);
        if (!alive) return;
        setPost(data);
      } catch (e) {
        if (!alive) return;
        setError(e instanceof Error ? e.message : 'Failed to load');
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    };

    load();

    return () => {
      alive = false;
    };
  }, [slug]);

  const contentIsHtml = useMemo(() => {
    const c = post?.content || '';
    return /<\w+/.test(c);
  }, [post]);

  if (loading) {
    return (
      <div className="cult-post-page">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-12 mono">Loading…</div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="cult-post-page">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-12 mono">{error}</div>
          </div>
        </div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="cult-post-page">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-12">
              <div className="mono">Post not found</div>
              <Link className="mono" to="/cult">
                Back to Cult
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cult-post-page">
      <section className="section cult-post-hero">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-12">
              <div className="mono">Cult</div>
              <h1 className="cult-post-title">{post.title}</h1>
              {post.publishedAt ? (
                <div className="mono cult-post-meta">
                  {new Date(post.publishedAt).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>

      <section className="section cult-post-body">
        <div className="wrapper grid-display">
          {post.coverUrl ? (
            <div className="row">
              <div className="col-12">
                <div className="cult-post-cover">
                  <img src={post.coverUrl} alt={post.title} />
                </div>
              </div>
            </div>
          ) : null}

          <div className="row">
            <div className="col-12">
              {post.excerpt ? (
                <p className="mono cult-post-excerpt">{post.excerpt}</p>
              ) : null}

              {post.content ? (
                <div
                  className="cult-post-content mono"
                  {...(contentIsHtml
                    ? { dangerouslySetInnerHTML: { __html: post.content } }
                    : {})}
                >
                  {!contentIsHtml ? post.content : null}
                </div>
              ) : null}

              <div className="cult-post-footer">
                <Link className="mono cult-post-back" to="/cult">
                  Back to Cult
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CultPost;
